module.exports = __webpack_public_path__ + "img/icon-calendar.5e3baba3.svg";